import React, { useEffect } from "react";
import { Image } from 'antd';
import { useTranslation } from 'react-i18next';
import { api } from "../host/Host";
import './assets/fotogallery.css'
import axios from "axios";
import { useStore } from "../store/Store";
import { motion } from "framer-motion"

function GalleryImages() {
  const {t} = useTranslation();
  const gallery=useStore(state=>state.gallery)
  const setgallery=useStore(state=>state.setgallery)

  useEffect(()=>{
    if(gallery.length===0){
      axios.get(`${api}/GetApi/GetPhotos/`).then((res) => {
        const length = Math.ceil(res.data.length / 4)
        const columns = []
        columns[0] = res.data.slice(0, length)
        columns[1] = res.data.slice(length, length + length)
        columns[2] = res.data.slice(2 * length, length * 3)
        columns[3] = res.data.slice(3 * length, res.data.length)
        setgallery(columns)
      }).catch(() => {})
    }
  }, [gallery.length, setgallery])

  const renderColumn = (items) => (
    !!items ? items.map((item, key) => (
      <div key={key} className="foto_link" style={{width:'100%', padding:'0px', height:'auto'}}>
        <figure className="foto_thumb">
          <Image height="100%" src={`${api}/Files/Photogallery/${item.fileName}`} alt={item[`description${t("lang")}`] || "Gallery image"} className="foto_image img1"/>
          <figcaption className="foto_caption">{item[`description${t("lang")}`]}</figcaption>
        </figure>
      </div>
    )) : ''
  );

  return (
    <Image.PreviewGroup>
      <motion.div initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}  transition={{ duration: 1.1 }} className="fotogalereya">
        <br/>
        <div className="foto">
          <div className="foto_column">{renderColumn(gallery[0])}</div>
          <div className="foto_column">{renderColumn(gallery[1])}</div>
          <div className="foto_column">{renderColumn(gallery[2])}</div>
          <div className="foto_column">{renderColumn(gallery[3])}</div>
        </div>
      </motion.div>
    </Image.PreviewGroup>
  );
}

export default GalleryImages;
